export default angular.module("ShareWithApp", [
    "KhBase"
]);
